function initEditor( target ) {

	CodeMirror.defineMode(
		"logoLike",
		function( config, parserConfig ) {

			const defaultKeywords = [
				'repeat', 'function', 'random', 'rand',
				'sum', 'add', 'difference', 'minus', 'multiply', 'times', 'divide', 'over', 'power', 'pow'
			];
			const keywords = [ ...app.keywordList, ...defaultKeywords ];
			const variable = /^\$[a-zA-Z_]\w*/;
			const number = /^(?:\d+(\.\d*)?|\.\d+)(?:e[+\-]?\d+)?/i;
			const functionCall = /\b\w+\([^)]*\)/;
			const comment = /^\/\/.*/;
			const hexColor = /#[0-9a-fA-F]{3,6}\b/; // Regex for hexadecimal color codes

			return {
				token: function( stream, state ) {
					if ( stream.eatSpace() ) return null;

					if ( stream.match( functionCall ) ) {
						return "function-call";
					}

					if ( stream.match( variable ) ) {
						return "variable";
					}

					if ( stream.match( number ) ) {
						return "number";
					}

					if ( stream.match( comment ) ) {
						return "comment";
					}

					if ( stream.match( hexColor ) ) { // Match hexadecimal color codes
						return "hex-color"; // Apply style for hexadecimal color codes
					}

					const word = stream.match( /\w+/ );
					if ( word && keywords.includes( word[ 0 ].toLowerCase() ) ) {
						return "keyword";
					}

					stream.next();
					return null;
				}
			};
		}
	);

	return CodeMirror.fromTextArea(
		document.getElementById( target ),
		{
			mode: "logoLike",
			indentWithTabs: true,
			tabSize: 2,
			indentUnit: 2,
			electricInput: /^\s*(?:\{|\})$/,
			lineNumbers: true,
			matchBrackets: true,
			closeBrackets: "{[()]}",
			overflowX: 'scroll',
			styleActiveLine: true,
			gutters: [ "CodeMirror-lint-markers" ], // Add gutter for lint markers if needed
		}
	);

}
